import { UserTypeEnum } from 'src/store/user/user';
import { extractUserIdFromAccessToken } from './extractUserIdFromAccessToken';
import { getUserIsRetailer } from './getUserIsRetailer';
import { getUserToken } from './getUserToken';


/**
 * Retrieves user information, including access token, user id, and user type.
 * Use it just once when tha app is launched, do not use it again!
 *
 * @returns {Promise<{accessToken: string, id: string, isLogged: boolean, userType: UserTypeEnum}>}
 *     An object containing the user's access token, user id, and user type.
 *     The access token is a string representing the user's authentication token.
 *     The user id is a string representing the user's unique identifier.
 *     The isLogged property is a boolean indicating whether the user is logged in.
 *     The userType property is a UserTypeEnum representing the user's type (either UserTypeEnum.USER_TYPE_RETAILER or UserTypeEnum.USER_TYPE_CONSUMER).
 */
export async function getUserInfo() {
  const { userToken, isUserAuthenticated } = await getUserToken();
  const id = extractUserIdFromAccessToken(userToken);
  const isRetailer = await getUserIsRetailer();
  const userType = isRetailer ? UserTypeEnum.USER_TYPE_RETAILER : UserTypeEnum.USER_TYPE_CONSUMER;

  return {
    accessToken: userToken,
    id,
    isLogged: isUserAuthenticated,
    userType,
  };
}
